import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-80" />
            <EfSection
                isVideo={true}
                autoPlay={true}
                loop={true}
                position="hover"
                theme="black"
                poster="https://websiteoss.ecoflow.com/upload/image/1724983598854/poster.png"
                pc="https://websiteoss.ecoflow.com/upload/video/1724983598563/%E9%AB%98%E5%8A%9F%E7%8E%87.mp4"
                title={t('I_title')}
            />
            <p className="desc">{t('I_desc')}</p>
            <EfSpec className="spec-80 spec-pc" />
        </div>
    );
}
